export const PERIODS = {
  DAY: 'D',
  MONTH: 'M',
  YEAR: 'Y',
};

export const CURRENCIES = {
  RUB: {
    CODE: 'RUB',
    SYMBOL: '₽',
  },
};

export const CHANNELS = {
  MOBILE_WEB: 'MOBILE_WEB',
  DESKTOP: 'DESKTOP',
  FRONTEND_WAYBACK_LINK: 'FRONTEND_WAYBACK_LINK',
  WL: 'WL',
};

export enum COLORS {
  DARK = 'dark',
  GREEN = 'green',
  BLUE = 'blue',
  ORANGE = 'orange',
  VIOLET = 'violet',
  RED = 'red',
}
